import { Alert } from '@efast_public/fjd-component-library';
import {
  ERROR_CASE_CLIENT,
  fjdAlertErrorBackendMsg,
  getErrorMsgClient
} from '../../../shared/utils/Error/ErrorCode';

interface ErrorComponentBackendProps {
  readonly errorCode?: string;
}

export function ErrorComponentBehoerdenServer(
  props: ErrorComponentBackendProps
): JSX.Element {
  const errorcodeMsg = props.errorCode
    ? ` (${props.errorCode})`
    : ' (Server nicht erreichbar oder fehlerhaft)';

  return (
    <Alert
      variant="error"
      message={fjdAlertErrorBackendMsg.concat(errorcodeMsg)}
    />
  );
}

interface ErrorComponentClientProps {
  readonly errorCase: ERROR_CASE_CLIENT;
}
export function ErrorComponentClient(
  props: ErrorComponentClientProps
): JSX.Element {
  return <Alert variant="error" message={getErrorMsgClient(props.errorCase)} />;
}
